import { AlertTriangle, Calendar, User, RefreshCw } from 'lucide-react'

const BrechaCard = ({ brecha, onClick }) => {
  const getSeveridadColor = (severidad) => {
    switch (severidad) {
      case 'alta':
        return 'bg-red-100 text-red-800 border-red-300'
      case 'media':
        return 'bg-yellow-100 text-yellow-800 border-yellow-300'
      case 'baja':
        return 'bg-green-100 text-green-800 border-green-300'
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300'
    }
  }

  const getEstadoColor = (estado) => {
    switch (estado) {
      case 'abierta':
        return 'bg-red-100 text-red-800'
      case 'en_proceso':
        return 'bg-blue-100 text-blue-800'
      case 'resuelta':
        return 'bg-green-100 text-green-800'
      default:
        return 'bg-gray-100 text-gray-800'
    }
  }

  const getEstadoLabel = (estado) => {
    switch (estado) {
      case 'abierta':
        return 'Abierta'
      case 'en_proceso':
        return 'En Proceso'
      case 'resuelta':
        return 'Resuelta'
      default:
        return estado
    }
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })
  }

  return (
    <div
      onClick={onClick}
      className="card hover:shadow-lg transition-shadow cursor-pointer border-l-4"
      style={{
        borderLeftColor: brecha.severidad === 'alta' ? '#ef4444' :
                         brecha.severidad === 'media' ? '#f59e0b' : '#10b981'
      }}
    >
      {/* Header */}
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2">
            <AlertTriangle className={`h-4 w-4 ${
              brecha.severidad === 'alta' ? 'text-red-500' :
              brecha.severidad === 'media' ? 'text-yellow-500' : 'text-green-500'
            }`} />
            <h3 className="font-semibold text-gray-900">{brecha.titulo}</h3>
          </div>
          <p className="text-sm text-gray-600 line-clamp-2">{brecha.descripcion}</p>
        </div>
      </div>

      {/* Badges */}
      <div className="flex flex-wrap gap-2 mb-3">
        <span className={`px-2 py-1 text-xs rounded-full border ${getSeveridadColor(brecha.severidad)}`}>
          Severidad: {brecha.severidad.charAt(0).toUpperCase() + brecha.severidad.slice(1)}
        </span>
        <span className={`px-2 py-1 text-xs rounded-full ${getEstadoColor(brecha.estado)}`}>
          {getEstadoLabel(brecha.estado)}
        </span>
        {brecha.ciclos_count > 0 && (
          <span className="px-2 py-1 text-xs rounded-full bg-purple-100 text-purple-800 flex items-center space-x-1">
            <RefreshCw className="h-3 w-3" />
            <span>{brecha.ciclos_count} ciclo{brecha.ciclos_count !== 1 ? 's' : ''} PDCA</span>
          </span>
        )}
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between text-xs text-gray-500 pt-3 border-t">
        <div className="flex items-center space-x-1">
          <Calendar className="h-3 w-3" />
          <span>Detectada: {formatDate(brecha.fecha_deteccion)}</span>
        </div>
        <div className="flex items-center space-x-1">
          <User className="h-3 w-3" />
          <span>{brecha.created_by}</span>
        </div>
      </div>
    </div>
  )
}

export default BrechaCard
